import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories, events } from "@/mocks/gossip";

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="主题分区"
          title="按主题找到你想看的那一口瓜"
          desc="六大主题分区，每一区都按最新节点排序。点进去即可看到该主题下的全部复盘档案。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((c) => {
            const count = events.filter((e) => e.categorySlug === c.slug).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-800">
                    {count} 篇复盘
                  </span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{c.name}</h3>
                <p className="mt-2 font-label text-sm leading-relaxed text-foreground-600 flex-1">{c.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 font-label text-sm text-primary-600">
                  进入分区
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}